import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
const internationalImage = require("../../../Assets/Images/canva/international.png");
const International = () => {
  let { t } = useTranslation();
  return (
    <section id="canvaInternational" className="BannerImgSeven">
     <Container  fluid  className="h-100">
      <Row className="h-100 align-items-center">
        <Col md={6} sm={12}>
          <div className="text-center h-100 my-3">
            <img className="img-fluid w-75" src={internationalImage} alt="" />
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className="h-100  py-3">
            <h3 className="heading">
              {/* {t("AboutUs")} */}
              Navigating International Tipping Hassles?
            </h3>
            <p className="pe-3 py-2 canvaText">
              {/* {t("AboutUsTextFirst")} */}
              With EasyTipping, ensure seamless tipping for international
              guests, enjoying instant currency conversion and zero exchange
              fees.
            </p>
            <p className="py-2 pe-3 canvaText">
              {/* {t("AboutUsText2nd")} */}
              Increase staff tips, boost morale, and enhance retention
              effortlessly.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
    </section>
  
  );
};

export default International;
